import { Map, List } from "lucide-react"
import { cn } from "@/lib/utils"

// The single map-toggle affordance for the mobile map-behind-sheet layouts
// (trip planner + guide), replacing the old per-day-card Map/List toggle. It
// flips the sheet between its docked snap (full itinerary) and a peek snap (map
// revealed), showing the routes + pins for whichever day is currently sticky —
// or all days when none. It used to pin itself over the sheet (fixed position);
// it now renders INSIDE the top header's action row via MapToggleContext, so it
// sits in the header flow with no fixed positioning of its own. Mobile-only by
// construction: the page only publishes a toggle config in its mobile /
// map-behind-sheet branch, and the header renders this button lg:hidden, so
// desktop (which shows the map alongside) is untouched.
export function MobileMapToggle({
  // True while the map is revealed (sheet below its docked snap) — drives the
  // icon + label the same way the old per-day toggle did.
  revealed,
  onToggle,
  className,
}: {
  revealed: boolean
  onToggle: () => void
  className?: string
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={revealed ? `Show itinerary` : `Show map`}
      className={cn(
        `flex h-9 items-center gap-1.5 rounded-full border border-border/60 bg-background/90 px-3 text-xs font-semibold text-muted-foreground transition-colors hover:bg-secondary/10 hover:text-secondary`,
        className
      )}
    >
      {revealed ? (
        <List className="size-4" />
      ) : (
        <Map className="size-4" />
      )}
      {revealed ? `List` : `Map`}
    </button>
  )
}
